<template>
  <div class="Scroll pl-8 pr-3 pb-3 w-full h-full">
    <h1 class="flex flex-col mb-3">
      <span class="text-sm text-white font-bold">Laporan Capture Map</span>
      <i class="text-xs text-white">(klik pada salah satu kolom untuk melakukan capture dari area map yang sedang tampil)</i>
    </h1>
    <div class="flex flex-col gap-3 mb-3 p-3 items-center border border-gray-300">
      <div class="flex flex-col gap-1">
        <small class="text-sm text-white">Image Capture</small>
        <div
          @click="toCapture('main')"
          class="relative flex justify-center items-center overflow-hidden border border-white rounded-md bg-white cursor-pointer hover:border-blue-500"
          style="width: 13rem;height: 10rem;">
          <div class="absolute z-10 top-0 flex justify-center items-center w-full h-full outline-none">
            <img
              :src="capture.a"
              style="w-full h-auto" />
          </div>
          <div class="flex justify-center items-center w-full h-full">
            <i class="material-icons text-2xl text-blue-500">photo_camera</i>
          </div>
          <div
            v-if="capture.inload"
            class="absolute z-20 top-0 flex justify-center items-center w-full h-full bg-gray-100">
            <i class="material-icons text-2xl text-blue-500 animate-spin">refresh</i>
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-1">
        <small class="text-sm text-white">Inset</small>
        <div
          @click="toCapture('inset')"
          class="relative flex justify-center items-center overflow-hidden border border-white rounded-md bg-white cursor-pointer hover:border-blue-500"
          style="width: 13rem;height: 10rem;">
          <div class="absolute z-10 top-0 flex justify-center items-center w-full h-full outline-none">
            <img
              :src="capture.b"
              style="w-full h-auto" />
          </div>
          <div class="flex justify-center items-center w-full h-full">
            <i class="material-icons text-2xl text-blue-500">photo_camera</i>
          </div>
          <div
            v-if="capture.inload"
            class="absolute z-20 top-0 flex justify-center items-center w-full h-full bg-gray-100">
            <i class="material-icons text-2xl text-blue-500 animate-spin">refresh</i>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-end items-center gap-1">
      <button
        @click="setActiveSubMenu('Tool')"
        class="px-1 py-1 w-32 h-8 bg-gray-400 rounded-md"
        type="button">
        <span class="text-xs text-white">Batal</span>
      </button>
      <button
        @click="setActiveSubMenu('ToolCaptureSave')"
        class="px-1 py-1 w-32 h-8 bg-blue-500 rounded-md"
        type="button">
        <span class="text-xs text-white">Lanjut</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'ToolCaptureScreenshot',
  data: () => ({
    step: 1
  }),
  computed: {
    ...mapGetters(['capture'])
  },
  methods: {
    ...mapActions([
      'toShowMenu',
      'toInitCapture',
      'toCapture'
    ]),
    ...mapMutations(['setActiveSubMenu'])
  },
  mounted: function () {
    this.toShowMenu()
    this.toInitCapture()
  }
}
</script>
